/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { resourceSchema } from './resourceSchema';

export const resourceWithSyncStatusSchema = z.object({
  isSynced: z.boolean(),
  get resource() {
    return resourceSchema;
  },
});
